import { ColumnsType } from 'antd/lib/table/interface';
import dayjs from 'dayjs';
import { Link } from 'react-router-dom';
import { findInvoiceRoute } from '../../../../layout/components/SearchInvoices';
import { ITourPackageReportList } from '../types/TourPackageTypes';

const TourPackageReportColumn = (): ColumnsType<ITourPackageReportList> => {
  return [
    {
      title: 'SL.',
      render: (_, data, index) => 1 + index,
    },
    {
      title: 'Date',
      dataIndex: 'payment_date',
      key: 'payment_date',
      render: (_, record) => {
        return `${dayjs(record.invoice_sales_date).format('DD MMM YYYY')}`;
      },
    },
    {
      title: 'Invoice No.',
      dataIndex: 'invoice_no',
      key: 'invoice_no',
    },
    {
      title: 'Client Name',
      dataIndex: 'client_name',
      key: 'client_name',
      // render: (_, record) => (
      //   <Link
      //     to={
      //       record.invoice_client_id
      //         ? `/clients/details/client-${record.invoice_client_id}`
      //         : `/combineClients/details/${record.invoice_combined_id}`
      //     }
      //   >
      //     {record.client_name}
      //   </Link>
      // ),
    },
    {
      title: 'Journey Date',
      render: (_, record) => {
        return `${dayjs(record.itour_from_date).format('DD MMM YYYY')} - ${dayjs(
          record.itour_to_date
        ).format('DD MMM YYYY')}`;
      },
    },
    {
      title: 'Group Name',
      dataIndex: 'group_name',
      key: 'group_name',
    },
    {
      title: 'Total Days',
      dataIndex: 'itour_day',
      key: 'itour_day',
    },
    {
      title: 'Total Nights',
      dataIndex: 'itour_night',
      key: 'itour_night',
    },

    {
      title: 'Total Amount',
      dataIndex: 'invoice_net_total',
      key: 'invoice_net_total',
      align: 'right',
      render: (_, record) => Number(record.invoice_net_total),
    },
  ];
};

export default TourPackageReportColumn;
